import { Component, computed, input } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import { DirectusTranslationPipe } from "../../../../common/pipes/directus-translation.pipe";
import { PathFromItemPipe } from "../../../../common/pipes/path-from-item.pipe";
import { sanitizeDirectusObject } from "../../../../common/utils/sanitize-directus-object";
import { ItemsLandingPageSplitBlock } from "../../../api/packbo/models/items-landing-page-split-block";

@Component({
    selector: "packbo-landing-page-split-block",
    templateUrl: "./landing-page-split-block.template.html",
    imports: [DirectusTranslationPipe, PathFromItemPipe, TranslocoPipe]
})
export class LandingPageSplitBlockComponent {
    public readonly landingPageSplitBlock = input.required<ItemsLandingPageSplitBlock>();
    public readonly learnMorePage = computed(() => {
        const learnMoreButton = sanitizeDirectusObject(this.landingPageSplitBlock()?.learn_more_button_ref);
        return sanitizeDirectusObject(learnMoreButton?.page_ref);
    });
}
